/**
 * Minimal Telegram WebApp typings for the bits we use directly.
 * The full SDK lives in @telegram-apps/sdk; this stub keeps the global
 * `Telegram.WebApp` (loaded from telegram-web-app.js) typed.
 */

export interface TelegramWebAppUser {
  id: number;
  first_name?: string;
  username?: string;
  language_code?: string;
}

export interface TelegramWebApp {
  initData: string;
  initDataUnsafe?: {
    user?: TelegramWebAppUser;
    start_param?: string;
  };
  ready(): void;
  expand(): void;
  close(): void;
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string>;
  HapticFeedback?: {
    impactOccurred(style: 'light' | 'medium' | 'heavy'): void;
    notificationOccurred(type: 'error' | 'success' | 'warning'): void;
  };
  BackButton?: {
    isVisible: boolean;
    show(): void;
    hide(): void;
    onClick(cb: () => void): void;
    offClick(cb: () => void): void;
  };
}

declare global {
  interface Window {
    Telegram?: {
      WebApp?: TelegramWebApp;
    };
  }
}

export function getTelegram(): TelegramWebApp {
  const tg = window.Telegram?.WebApp;
  if (!tg) {
    throw new Error('Telegram WebApp SDK not loaded — open this URL inside Telegram.');
  }
  return tg;
}

export function tryGetTelegram(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}
